<template>
  <div id="app">
    <!-- 公共区域：导航栏 -->
    <div class="navbar-container">
      <nav class="navbar">
        <div class="nav-left-svg" aria-hidden="true">
          <img src="/shop/nav-right.png" alt="navbar decoration" />
        </div>
        <div class="nav-right-svg" aria-hidden="true">
          <img src="/shop/nav-left.png" alt="navbar right decoration" />
        </div>
        <div class="nav-left-logo" aria-hidden="true">
          <div class="footer-logo" @click="goToHome()">
            <img src="./assets/logo.png" alt="LOGO"  />
          </div>
        </div>
        <div class="container">
          <div class="nav-links">
            <ul>
              <li><router-link to="/">网站首页</router-link></li>
              <li><router-link to="/success">成功案例</router-link></li>
              <li><router-link to="/news">新闻资讯</router-link></li>
              <li><router-link to="/about">关于我们</router-link></li>
            </ul>
          </div>
        </div>
        <div class="nav-right-btn" aria-hidden="false">
          <button class="nav-action" @click="goAdmin()">登录管理后台</button>
        </div>
        <!-- 汉堡按钮（仅小屏显示） -->
        <div class="hamburger-container">
          <button class="hamburger" @click="toggleMenu()" :class="{ 'is-active': isMenuOpen }">
            <div class="hamburger__line"></div>
            <div class="hamburger__line"></div>
            <div class="hamburger__line"></div>
          </button>
          <div class="dropdown-menu" v-show="isMenuOpen">
            <button class="dropdown-item" @click="toAbout()">关于我们</button>
            <button class="dropdown-item" @click="toNews()">新闻资讯</button>
            <button class="dropdown-item" @click="toSuccess()">成功案例</button>
          </div>
        </div>
      </nav>
    </div>

    <!-- 公共区域：轮播图 -->
    <MultiCarousel :is-target-page="isTargetPage" />

    <!-- 路由组件渲染位置（首页/业务范围/新闻资讯/关于我们 在这里显示） -->
    <router-view />

    <!-- 公共区域：页脚 -->
    <footer class="footer-section">
      <div class="container">
        <div class="footer-content">
          <div class="footer-left">
            <div class="footer-contact">
              <div class="qrcode"><img src="/shop/qrcode.png" alt="扫码添加微信" /></div>
              <div class="contact-details">
                <p> 微信号：shop9100 </p>
                <p> 地址：中国·莆田·辰华财富中心 </p>
              </div>
            </div>
          </div>
          <div class="footer-right">
            <div class="footer-nav">
              <h4>业务范围</h4>
              <ul>
                <li style="color: #666666; font-size: 14px;">SaaS建站</li>
                <li style="color: #666666; font-size: 14px;">Vepay信用卡</li>
                <li style="color: #666666; font-size: 14px;">AB跳转轮训系统</li>
                <li style="color: #666666; font-size: 14px;">斗篷Cloak系统</li>
              </ul>
            </div>
            <div class="footer-nav">
              <h4>新闻资讯</h4>
              <ul>
                <li><router-link to="/news">公司新闻</router-link></li>
                <li><router-link to="/news">行业新闻</router-link></li>
              </ul>
            </div>
            <div class="footer-nav">
              <h4>关于我们</h4>
              <ul>
                <li><router-link to="/about">公司简介</router-link></li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </footer>

      <div class="side-contact">
      <div class="contact-btn">
        <i class="contact-icon"></i>
        <div class="contact-preview" aria-hidden="true">
          <img src="/shop/qrcode.png" alt="contact preview" />
        </div>
      </div>
      <div class="back-to-top" @click="scrollToTop" title="回到顶部">
        <i class="back-icon"></i>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'App',
  data() {
    return {
      scrolled: false,
      isMenuOpen: false
    }
  },
    computed: {
    isTargetPage() {
    const targetPaths = ['/success', '/news', '/about'];

    const isDetailPage = this.$route.path.startsWith('/detail/');

    return targetPaths.includes(this.$route.path) || isDetailPage;
    }
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll);
    this.initProcessAnimation();
    document.addEventListener('click', this.handleDocumentClick);
  },
  methods: {
    handleScroll() {
      this.scrolled = window.scrollY > 50;
    },
    scrollToTop() {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    },
    goAdmin() {
      window.open('https://shop910.com/admin', '_blank');
    },
goToHome() {

  const currentPath = this.$route.path;

  if (currentPath !== '/') {
    this.$router.push('/');
  }else {

    this.scrollToTop();
  }
},
    initProcessAnimation() {
      const processObserver = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            setTimeout(() => {
              entry.target.classList.add('animate');
            }, entry.target.dataset.index * 100);
            processObserver.unobserve(entry.target);
          }
        });
      }, {
        threshold: 0.15,
        rootMargin: '0px 0px -50px 0px'
      });
      document.querySelectorAll('.process-step').forEach((step, index) => {
        step.dataset.index = index;
        processObserver.observe(step);
      });
    },
    toggleMenu() {
      this.isMenuOpen = !this.isMenuOpen;
    },
    toAbout() {    
  const currentPath = this.$route.path;
  if (currentPath !== '/about') {
    this.$router.push('/about');
     this.closeMenu();
  }else {
    this.scrollToTop();
     this.closeMenu();
    }   
  },
    toSuccess() {
       const currentPath = this.$route.path;
  if (currentPath !== '/success') {
    this.$router.push('/success');
     this.closeMenu();
  }else {
    this.scrollToTop();
     this.closeMenu();
    }   
    },
    toNews() {
  const currentPath = this.$route.path;
  if (currentPath !== '/news') {
    this.$router.push('/news');
     this.closeMenu();
  }else {
    this.scrollToTop();
     this.closeMenu();
    }   
    },
    closeMenu() {
      this.isMenuOpen = false;
    },
    handleDocumentClick(e) {
      if (!this.isMenuOpen) return;
      const hamburgerContainer = document.querySelector('.hamburger-container');
      const dropdownMenu = document.querySelector('.dropdown-menu');
      if (
        !hamburgerContainer?.contains(e.target) &&
        !dropdownMenu?.contains(e.target)
      ) {
        this.isMenuOpen = false;
      }
    }
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll);
    document.removeEventListener('click', this.handleDocumentClick);
  }
}
</script>

<style>
/* 全局公共样式 */
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}
body {
  font-family: 'Arial', 'Helvetica Neue', Helvetica, sans-serif;
  color: #333;
  line-height: 1.6;
  margin: 0;
  padding: 0;
  background-color: #fff;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
.container {
  width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

/* 导航栏公共样式 */
.navbar-container {
  position: relative;
  z-index: 1000;
}
.navbar {
  position: absolute;
  top: -11px;
  left: 50%;
  transform: translateX(-50%);
  width: 100%;
  max-width: 1000px;
  background-color: #ffffff;
  padding: 20px 0;
  z-index: 10;
  border-radius: 0 0 0 0;
  overflow: visible;
  height: 70px;
}
.navbar .container {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
}
.nav-links {
  width: 100%;
  padding: 0 10px;
}
.nav-links ul {
  display: flex !important;
  list-style: none;
  margin: 0;
  padding: 0;
  justify-content: center;
  max-width: 100%;
}
.nav-links ul li {
  margin: 0 30px;
  position: relative;
}
.nav-links ul li a {
  color: #333;
  text-decoration: none;
  font-size: 18px;
  font-weight: 500;
  transition: color 0.3s;
  letter-spacing: 0.5px;
  padding: 5px 0;
}
.nav-links ul li a:hover {
  color: #007bff;
}
.nav-left-logo {
  position: absolute;
  left: 20px;
  top: 50%;
  transform: translateY(-50%);
  z-index: 15;
  pointer-events: auto;
}
.nav-left-logo .footer-logo {
  display: inline-block;
  padding: 4px;
  background-color: #ffffff;
  border-radius: 4px;
  line-height: 0;
}
.nav-left-logo .footer-logo img {
  display: block;
  width: 150px;
  height: auto;
  margin: 0;
}
.nav-right-btn {
  position: absolute;
  right: 20px;
  top: 50%;
  transform: translateY(-50%);
  z-index: 15;
  pointer-events: auto;
}
.nav-right-btn .nav-action {
  background: #232650;
  color: #fff;
  border: none;
  padding: 10px 16px;
  border-radius: 6px;
  font-size: 14px;
  cursor: pointer;
  box-shadow: 0 6px 16px rgba(0, 123, 255, 0.18);
}

/* 左侧导航图标样式 */
.nav-left-svg {
  position: absolute;
  top: 0;
  left: 0;
  transform: translateX(-99%);
  height: 100%;
  width: auto;
  margin: 0;
  z-index: 14;
  pointer-events: none;
  display: block;
}
.nav-left-svg img {
  display: block;
  height: 100%;
  width: auto;
  object-fit: cover;
}

/* 右侧导航图标样式 */
.nav-right-svg {
  position: absolute;
  top: 0;
  right: 0;
  transform: translateX(100%);
  height: 100%;
  width: auto;
  margin: 0;
  z-index: 14;
  pointer-events: none;
}
.nav-right-svg img {
  display: block;
  height: 100%;
  width: auto;
  object-fit: cover;
}

/* 汉堡菜单样式 */
.hamburger-container {
  display: none;
  position: absolute;
  right: 20px;
  top: 50%;
  transform: translateY(-50%);
  z-index: 20;
}
.hamburger {
  background: transparent;
  border: transparent;
  cursor: pointer;
  padding: 0;
}
.hamburger__line {
  background: #ffffff;
  margin: 5px 0;
  height: 4px;
  width: 32px;
  transition: all 0.3s ease-out; /* 原有过渡保留，确保变换平滑 */
}
.hamburger.is-active .hamburger__line:nth-child(1) {
  transform: translateY(9px) rotate(45deg) !important; /* 第一行上移并旋转 */
  opacity: 1; /* 取消hover时的透明效果 */
}
.hamburger.is-active .hamburger__line:nth-child(2) {
  opacity: 0; /* 中间行隐藏 */
}
.hamburger.is-active .hamburger__line:nth-child(3) {
  transform: translateY(-9px) rotate(-45deg); /* 第三行下移并旋转 */
  opacity: 1; /* 取消hover时的透明效果 */
}

.dropdown-menu {
  position: absolute;
  top: 100%;
  right: 0;
  width: 200px;
  background-color: #232650;
  border-radius: 0 0 12px 12px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.2);
  padding: 10px 0;
  z-index: 999;
}
.dropdown-item {
  display: block;
  width: 100%;
  background: transparent;
  border: none;
  color: #ffffff;
  font-size: 16px;
  padding: 12px 20px;
  text-align: left;
  cursor: pointer;
  transition: background-color 0.3s;
}
.dropdown-item:hover {
  background-color: #353979;
}

/* 页脚公共样式 */
.footer-section {
  background-color: #232650;
  padding: 60px 0;
}
.footer-content {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
}
.footer-left {
  width: 30%;
}
.footer-logo {
  display: inline-block;
  width: auto;
  height: auto;
  padding: 4px;
  background-color: #232650;
  border-radius: 4px;
  line-height: 0;
  margin-bottom: 0;
}
.footer-logo img {
  display: block;
  width: 120px;
  height: auto;
  margin: 0;
}
.footer-contact {
  display: flex;
  flex-direction: column;
  align-items: left;
  gap: 20px;
}
.qrcode img {
  width: 170px;
  height: 170px;
  margin-bottom: 5px;
}
.qrcode p {
  font-size: 12px;
  text-align: center;
  color: #ffffff;
}
.contact-details p {
  font-size: 14px;
  margin-bottom: 8px;
  display: flex;
  align-items: center;
  gap: 8px;
  color: #ffffff;
}
.contact-details img {
  width: 16px;
  height: 16px;
}
.footer-right {
  width: 65%;
  display: flex;
  justify-content: space-between;
}
.footer-nav h4 {
  font-size: 16px;
  margin-bottom: 15px;
  color: #ffffff;
}
.footer-nav ul {
  list-style: none;
}
.footer-nav ul li {
  margin-bottom: 8px;
}
.footer-nav ul li a {
  color: #666;
  text-decoration: none;
  font-size: 14px;
  transition: color 0.3s;
}
.footer-nav ul li a:hover {
  color: #0056b3;
}

/* 响应式公共样式 */
@media (max-width: 1200px) {
  .container {
    width: 960px;
  }
}
@media (max-width: 1024px) {
  .nav-left-svg,
  .nav-right-svg {
    display: none;
  }
}
@media (max-width: 992px) {
  .nav-left-svg,
  .nav-right-svg {
    display: none;
  }
  .container {
    width: 720px;
  }
}
@media (max-width: 768px) {
  .container {
    width: 540px;
  }
  .nav-links ul {
    display: none;
  }
  .nav-left-logo,
  .nav-right-btn {
    display: none;
  }
  .nav-left-svg,
  .nav-right-svg {
    display: none;
  }
  .qrcode img {
  width: 100px;
  height: 100px;
  margin-bottom: 5px;
}
}
@media (max-width: 576px) {
  .container {
    width: 100%;
    padding: 0 15px;
  }
  .footer-contact {
    flex-direction: column;
    align-items: center;
    gap: 10px;
  }
  .qrcode {
    text-align: left;
  }
  .qrcode img {
  width: 100px;
  height: 100px;
  margin-bottom: 5px;
}
  .footer-left .footer-logo {
    display: none;
  }
  .nav-left-logo {
    display: block !important;
  }
  .nav-right-btn {
    display: none !important;
  }
  .navbar {
    position: fixed !important;
    top: 0 !important;
    left: 50% !important;
    transform: translateX(-50%) !important;
    width: 100% !important;
    max-width: 100% !important;
    height: 60px !important;
    padding: 5px 0 !important;
    z-index: 999 !important;
    background-color: #232650 !important;
  }
  .nav-links {
    display: none !important;
  }
  .nav-left-logo .footer-logo img {
    width: 100px !important;
    background: none;
  }
  .hamburger-container {
    display: block !important;
  }

  .footer-nav h4 {
  font-size: 14px;
  margin-bottom: 15px;
  color: #ffffff;
}
.footer-nav ul {
  list-style: none;
}
.footer-nav ul li {
  margin-bottom: 8px;
}
.footer-nav ul li a {
  color: #666;
  text-decoration: none;
  font-size: 12px;
  transition: color 0.3s;
}
.side-contact {
    position: fixed !important;
    top: auto !important; /* 取消垂直居中，改为底部定位 */
    bottom: 60px !important; /* 距离底部20px */
    right: 20px !important; /* 距离右侧20px */
    transform: none !important; /* 取消 translateY(-50%) */
    gap: 10px !important; /* 缩小两个按钮间距 */
    z-index: 999 !important;
  }
  /* 缩小按钮尺寸（原55px → 40px） */
  .side-contact .contact-btn,
  .side-contact .back-to-top {
    width: 40px !important;
    height: 40px !important;
    box-shadow: 0 3px 10px rgba(0, 123, 255, 0.3) !important; /* 同步缩小阴影 */
  }
  /* 缩小按钮内图标（原26px → 20px） */
  .side-contact .contact-icon,
  .side-contact .back-icon {
    width: 20px !important;
    height: 20px !important;
    mask-size: 70% !important; /* 适配图标尺寸 */
  }
  /* 缩小二维码预览框（适配手机屏幕） */
  .side-contact .contact-preview {
    width: 120px !important; /* 原160px → 120px */
    padding: 5px !important; /* 原8px → 5px */
  }
  .footer-section .container {
    padding: 0 15px !important;
  }
  /* 页脚整体改为垂直排列，所有元素居中 */
  .footer-content {
    flex-direction: column !important;
    align-items: center !important;
    gap: 30px !important; /* 三个部分的垂直间距 */
  }
  /* 左侧区域：宽度100%，内部元素居中 */
  .footer-left {
    width: 100% !important;
    text-align: center !important;
  }
  /* 左侧内部：二维码+联系方式垂直居中排列 */
  .footer-contact {
    flex-direction: column !important;
    align-items: center !important;
    gap: 15px !important; /* 二维码和联系方式的间距 */
  }
  /* 二维码：居中显示，调整大小适配手机 */
  .qrcode {
    text-align: center !important;
    margin: 0 auto !important;
  }
  .qrcode img {
    width: 120px !important;
    height: 120px !important;
  }
  /* 联系方式：居中显示 */
  .contact-details {
    text-align: center !important;
  }
  .contact-details p {
    justify-content: center !important; /* 图标和文字居中对齐 */
  }
  /* 右侧导航区域：宽度100%，水平居中排列 */
  .footer-right {
    width: 100% !important;
    justify-content: center !important; /* 三个导航栏居中 */
    gap: 20px !important; /* 三个导航栏的间距 */
    flex-wrap: wrap !important; /* 屏幕过小时自动换行，不挤压 */
  }
  /* 导航栏内部：文字居中，适配垂直布局 */
  .footer-nav {
    text-align: center !important;
  }
  .footer-nav ul {
    justify-content: center !important;
  }
}

/* 侧边联系按钮样式 */
.side-contact {
  position: fixed;
  right: 30px;
  top: 50%;
  transform: translateY(-50%);
  display: flex;
  flex-direction: column;
  gap: 15px;
  z-index: 999;
}
.contact-btn {
  position: relative;
  width: 55px;
  height: 55px;
  background-color: #007bff;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 4px 15px rgba(0, 123, 255, 0.3);
}
.contact-preview {
  display: none;
  position: absolute;
  right: 100%;
  top: 50%;
  transform: translateY(-50%);
  width: 160px;
  height: auto;
  padding: 8px;
  background: #fff;
  border-radius: 6px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);
  overflow: hidden;
  z-index: 1000;
}
.contact-preview img {
  display: block;
  width: 100%;
  height: auto;
}
.contact-btn:hover .contact-preview {
  display: block;
}
.back-to-top {
  width: 55px;
  height: 55px;
  background-color: #007bff;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 4px 15px rgba(0, 123, 255, 0.3);
}
.back-to-top:hover {
  transform: translateY(-5px);
  background-color: #0056b3;
}
.contact-btn:hover,
.back-to-top:hover {
  background-color: #0056b3;
  transform: translateY(-5px);
  box-shadow: 0 8px 25px rgba(0, 123, 255, 0.4);
}
.contact-icon,
.back-icon {
  width: 26px;
  height: 26px;
  background-color: #fff;
}
.contact-icon {
  mask-image: url("./assets/wechat.png"); 
  mask-size: contain;
  mask-repeat: no-repeat;
  mask-position: center;
}
.back-icon {
  mask-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpolyline points='18 15 12 9 6 15'%3E%3C/polyline%3E%3C/svg%3E");
  mask-size: contain;
  mask-repeat: no-repeat;
  mask-position: center;
}
</style>